export function case_status_key(status = '') {
  return String(status || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function status_dot_class(status = '') {
  const normalized = case_status_key(status);
  return CASE_STATUS_DOT_RULES.find((rule) => rule.matches(normalized))?.class_name || 'bg-success';
}

export function status_dot_style(status_color = '') {
  const color = String(status_color || '').trim();
  return /^#[0-9a-f]{6}$/i.test(color) ? { backgroundColor: color } : {};
}

const CASE_STATUS_DOT_RULES = [
  {
    class_name: 'bg-secondary-subtle',
    matches: (status) => ['closed', 'complete', 'resolved'].some((token) => status.includes(token)),
  },
  {
    class_name: 'bg-warning',
    matches: (status) => ['pending', 'evidence', 'verification'].some((token) => status.includes(token)),
  },
];

const CASE_STATUS_FILTERS = [
  {
    key: 'closed-30d',
    matches: (status) => ['closed', 'complete', 'resolved'].some((token) => status.includes(token)),
  },
  {
    key: 'pending-evidence',
    matches: (status) => ['pending', 'evidence'].every((token) => status.includes(token)),
  },
  {
    key: 'in-progress',
    matches: (status) => status.includes('progress'),
  },
];

export function case_status_filter_key(status = '') {
  const normalized = case_status_key(status);
  return CASE_STATUS_FILTERS.find((filter) => filter.matches(normalized))?.key || 'in-review';
}
